import type { Hook } from 'phoenix_live_view';
import { pushPanelLoadEvent } from './push-panel-load';

/**
 * Pushes "load-decision-surface-lite" when the target game id is set or changes.
 */
export const loadDecisionSurfaceLite: Hook = {
  mounted() {
    pushPanelLoadEvent(this, 'load-decision-surface-lite');
  },
  updated() {
    pushPanelLoadEvent(this, 'load-decision-surface-lite');
  },
};
